// lib/guestVisit.js
// 게스트 추가 창(수업관리·실시간 심박)의 방문 종류(무료체험·드랍인)와 참석 기록 조회
// (docs/architecture/admin-trends-design.md 1.6절 "드랍인", docs/api/admin.md)
import { apiJson } from "./api";

export const VISIT_KINDS = [
  { value: "trial", label: "무료체험" },
  { value: "drop_in", label: "드랍인" },
];

export function visitKindLabel(kind) {
  return kind === "drop_in" ? "드랍인" : "무료체험";
}

export function phoneDigits(phone) {
  return String(phone || "").replace(/\D/g, "");
}

// 전화번호 숫자가 10자리 이상이면 그 번호가 전에 참석완료한 적이 있는지 묻는다. 실패하면 null(창은 고른 종류 그대로).
// 번호를 치는 동안 부르는 미리 고르기라 어떤 오류도 전역 팝업을 띄우지 않는다(옛 API의 404 포함). 서버가 아프면 [확정]이 오류를 보인다
export async function fetchVisitHistory(phone) {
  const digits = phoneDigits(phone);
  if (digits.length < 10) return null;
  try {
    return await apiJson(
      `/v1/admin/free-trial-requests/visit-history?phone=${digits}`,
      { quietStatuses: [400, 401, 403, 404, 405, 500, 503] }
    );
  } catch {
    return null;
  }
}

// "10.03 무료체험 참석 기록이 있어요" (참석 기록이 없으면 "")
export function visitHistoryNote(history) {
  if (!history?.attended) return "";
  const [, m, d] = String(history.last_attended_date || "").split("-");
  const when = m && d ? `${m}.${d} ` : "";
  return `${when}${visitKindLabel(
    history.last_attended_kind
  )} 참석 기록이 있어요`;
}

// 게스트 추가 창이 함께 쓰는 상태 변화: 번호를 바꾸면 참석 기록을 다시 보고, 코치가 종류를 직접 고르지 않았으면
// 참석 기록이 있을 때 드랍인, 없을 때 처음 값으로 둔다. 늦게 온 응답(그 사이 번호가 바뀜)은 버린다
export async function applyVisitHistory(form, phone, defaultKind = "trial") {
  const digits = phoneDigits(phone);
  form.visitNote = "";
  if (!form.visitKindTouched) form.visitKind = defaultKind;
  const history = await fetchVisitHistory(phone);
  if (phoneDigits(form.phone) !== digits) return;
  form.visitNote = visitHistoryNote(history);
  if (history?.attended && !form.visitKindTouched) form.visitKind = "drop_in";
}
